import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import store from './store'
import '@/LabelStudio/static/css/main.css'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
import wb from './registerServiceWorker'

loadFonts()

const app = createApp(App)
app.config.globalProperties.$workbox = wb
app
  .use(i18n)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueTelInput)
  .mount('#app')
